<template>
  <span class="ticket-download-documents">
    <button
      v-if="icon"
      :disabled="unabled"
      @click="zipper"
      class="btn btn-default btn-icon btn-fill btn-sm"
      type="button"
      title="Download documentação"
    >
          <i class="fa fa-download"></i>
        </button>
    <button
      v-else
      :disabled="unabled"
      class="btn btn-block btn-fill btn-wd btn-default"
      @click="zipper()"
    >
      Download Documentação
    </button>
    <div
      v-show="false"
      id="canvasPlace"
    ></div>
  </span>
</template>

<script>
  import downloadJs from 'downloadjs'
  import JSZip from 'jszip'
  import Couchdb from 'src/services/Couchdb'
  import {mapGetters} from 'vuex'
  import {imageSuportService} from 'src/services/ImageSuport'

  export default {
    name: 'ticket-download-documents',
    props: {
      icon: {
        default: false
      },
      ticketProp: {
        default: undefined
      }
    },
    methods: {
      async zipper () {
        let zip = new JSZip()
        let attachments = await Couchdb.connection('docs')
          .view({
            ddoc: 'docs-by-reference-id',
            view: 'docs-by-reference-id',
            key: this.ticketProp ? this.ticketProp._id : this.ticket._id
          })
        attachments = attachments.rows.map(item => item.value)
        let documents = []
        for (let file of attachments) {
          let anexo = false
          let name = null
          let value = null
          for (let index in file._attachments) {
            name = index
            anexo = await Couchdb.connection('docs').getAttachment(file._id, index)
            if (anexo.type === 'image/jpeg' || anexo.type === 'image/png') {
              value = await imageSuportService.resizeImage(anexo,
                {
                  canvasId: 'canvasPlace',
                  maxWidth: 640,
                  maxHeight: 480,
                  maxQuality: 100
                }
              )
            } else {
              value = anexo
            }
            documents.push({name: name, value: value})
          }
        }
        for (let file of documents) {
          if (file.value.type === 'application/pdf') {
            zip.file(file.name, file.value, 'application/pdf')
          } else {
            zip.file(file.name, file.value.blob)
          }
        }

        zip.generateAsync({type: 'blob'})
          .then(function (blob) {
            downloadJs(blob, 'documentacao.zip')
          })
      }
    },
    computed: {
      ...mapGetters('tickets', ['ticket']),
      unabled: function () {
        const tkt = this.ticketProp ? this.ticketProp : this.ticket
        return (tkt && !tkt.documentedAt) || !this.$can('tickets.downloadDoc')
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Tickets/Actions/TicketDownloadDocuments.vue